import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

export default function AuthCallback() {
    const navigate = useNavigate();
    const { user } = useAuth();

    useEffect(() => {
        // If user is loaded (which happens in AuthProvider on mount/update), redirect to home
        // The cookie should have been set by the backend redirect
        if (user) {
            // Ensure flag is set if we have a user
            localStorage.setItem('auth_status', 'logged_in');
            navigate('/');
        } else {
            // We just came back from Google, so we should be logged in.
            // Set the flag so that on reload/redirect, AuthContext tries to fetch the user.
            localStorage.setItem('auth_status', 'logged_in');

            // Optional: Add a timeout or check if cookie exists, then reload user
            // For now, just redirect to home after a short delay to allow AuthContext to fetch user
            const timer = setTimeout(() => {
                window.location.href = '/'; // Force reload to ensure cookies are sent if needed
            }, 1000);
            return () => clearTimeout(timer);
        }
    }, [user, navigate]);

    return (
        <div className="min-h-screen flex items-center justify-center">
            <div className="text-xl">Authenticating...</div>
        </div>
    );
}
